const europeanUnion = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK',
  'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE',
  'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL',
  'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB'
]

const communicationCountries = [
  'sg', 'th', 'my', 'id', 'au', 'nz', 'hk', 'ph', 'cn', 'kr'
]

const defaultCountries = [
  {
    code: 'au',
    name: 'Australia'
  },
  {
    code: 'my',
    name: 'Malaysia'
  },
  {
    code: 'nz',
    name: 'New Zealand'
  },
  {
    code: 'ph',
    name: 'Philippines'
  },
  {
    code: 'sg',
    name: 'Singapore'
  }
]

const continentsWithCountries = [
  {
    name: {
      lng_en: 'North America',
      lng_id: 'Amerika Utara',
      lng_th: 'อเมริกาเหนือ',
      lng_zh: '北美洲',
      lng_ko: '북아메리카',
      'vi-VN': 'Bắc Mỹ',
      'ja-JP': '北米',
      'zh-TW': '北美洲'
    },
    group: 'America',
    countries: [
      {
        name: {
          lng_en: 'Canada',
          lng_id: 'Kanada',
          lng_th: 'แคนาดา',
          lng_zh: '加拿大',
          lng_ko: '캐나다',
          'vi-VN': 'Canada',
          'ja-JP': 'カナダ',
          'zh-TW': '加拿大'
        },
        url: 'https://www.sephora.com/ca/en'
      },
      {
        name: {
          lng_en: 'Mexico',
          lng_id: 'Mexico',
          lng_th: 'เม็กซิโก',
          lng_zh: '墨西哥',
          lng_ko: '멕시코',
          'vi-VN': 'Mexico',
          'ja-JP': 'メキシコ',
          'zh-TW': '墨西哥'
        },
        url: 'https://www.sephora.com.mx'
      },
      {
        name: {
          lng_en: 'United States',
          lng_id: 'Amerika Serikat',
          lng_th: 'สหรัฐอเมริกา',
          lng_zh: '美國',
          lng_ko: '미국',
          'vi-VN': 'Hoa Kỳ',
          'ja-JP': 'アメリカ',
          'zh-TW': '美國'
        },
        url: 'https://www.sephora.com'
      }
    ]
  },
  {
    name: {
      lng_en: 'South America',
      lng_id: 'Amerika Selatan',
      lng_th: 'อเมริกาใต้',
      lng_zh: '南美洲',
      lng_ko: '남아메리카',
      'vi-VN': 'Nam Mỹ',
      'ja-JP': '南アメリカ',
      'zh-TW': '南美洲'
    },
    group: 'America',
    countries: [
      {
        name: {
          lng_en: 'Brazil',
          lng_id: 'Brazil',
          lng_th: 'บราซิล',
          lng_zh: '巴西',
          lng_ko: '브라질',
          'vi-VN': 'Brazil',
          'ja-JP': 'ブラジル',
          'zh-TW': '巴西'
        },
        url: 'https://www.sephora.com.br'
      }
    ]
  },
  {
    name: {
      lng_en: 'Asia',
      lng_id: 'Asia',
      lng_th: 'เอเชีย',
      lng_zh: '亞洲',
      lng_ko: '아시아',
      'vi-VN': 'Châu Á',
      'ja-JP': 'アジア',
      'zh-TW': '亞洲'
    },
    group: 'Asia',
    countries: [
      {
        name: {
          lng_en: 'Bahrain',
          lng_id: 'Bahrain',
          lng_th: 'บาห์เรน',
          lng_zh: '巴林',
          lng_ko: '바레인',
          'vi-VN': 'Bahrain',
          'ja-JP': 'バーレーン',
          'zh-TW': '巴林'
        },
        url: 'https://www.sephora.bh'
      },
      {
        name: {
          lng_en: 'China',
          lng_id: 'Cina',
          lng_th: 'จีน',
          lng_zh: '中國',
          lng_ko: '중국',
          'vi-VN': 'Trung Quốc',
          'ja-JP': '中国',
          'zh-TW': '中國'
        },
        url: 'https://www.sephora.cn'
      },
      {
        name: {
          slug: 'hong-kong',
          lng_en: 'Hong Kong SAR',
          lng_id: 'Hong Kong SAR',
          lng_th: 'เขตบริหารพิเศษฮ่องกง',
          lng_zh: '香港特別行政區',
          lng_ko: '홍콩특별행정구',
          'vi-VN': 'Tìm kiếm và cứu hộ Hong Kong',
          'ja-JP': '香港SAR',
          'zh-TW': '香港特別行政區'
        },
        url: 'https://www.sephora.hk'
      },
      {
        name: {
          lng_en: 'Indonesia',
          lng_id: 'Indonesia',
          lng_th: 'อินโดนีเซีย',
          lng_zh: '印尼',
          lng_ko: '인도네시아',
          'vi-VN': 'Indonesia',
          'ja-JP': 'インドネシア',
          'zh-TW': '印度尼西亞'
        },
        url: 'https://www.sephora.co.id'
      },
      {
        name: {
          lng_en: 'Kuwait',
          lng_id: 'Kuwait',
          lng_th: 'คูเวต',
          lng_zh: '科威特',
          lng_ko: '쿠웨이트',
          'vi-VN': 'Kuwait',
          'ja-JP': 'クウェート',
          'zh-TW': '科威特'
        },
        url: 'https://www.sephora.com.kw'
      },
      {
        name: {
          lng_en: 'Malaysia',
          lng_id: 'Malaysia',
          lng_th: 'มาเลเซีย',
          lng_zh: '馬拉西亞',
          lng_ko: '말레이시아',
          'vi-VN': 'Malaysia',
          'ja-JP': 'マレーシア',
          'zh-TW': '馬來西亞'
        },
        url: 'https://www.sephora.my'
      },
      {
        name: {
          lng_en: 'Oman',
          lng_id: 'Oman',
          lng_th: 'โอมาน',
          lng_zh: '阿曼',
          lng_ko: '오만',
          'vi-VN': 'Oman',
          'ja-JP': 'オマーン',
          'zh-TW': '阿曼'
        },
        url: 'https://www.sephora.om'
      },
      {
        name: {
          lng_en: 'Philippines',
          lng_id: 'Filipina',
          lng_th: 'ฟิลิปปินส์',
          lng_zh: '菲律賓',
          lng_ko: '필리핀',
          'vi-VN': 'Phi-líp-pin',
          'ja-JP': 'フィリピン',
          'zh-TW': '菲律賓'
        },
        url: 'https://www.sephora.ph'
      },
      {
        name: {
          lng_en: 'Qatar',
          lng_id: 'Qatar',
          lng_th: 'กาตาร์',
          lng_zh: '卡塔爾',
          lng_ko: '카타르',
          'vi-VN': 'Qatar',
          'ja-JP': 'カタール',
          'zh-TW': '卡塔爾'
        },
        url: 'https://www.sephora.qa'
      },
      {
        name: {
          lng_en: 'Saudi Arabia',
          lng_id: 'Arab Saudi',
          lng_th: 'ซาอุดีอาระเบีย',
          lng_zh: '沙特阿拉伯',
          lng_ko: '사우디아라비아',
          'vi-VN': 'Ả Rập Saudi',
          'ja-JP': 'サウジアラビア',
          'zh-TW': '沙特阿拉伯'
        },
        url: 'https://www.sephora.sa'
      },
      {
        name: {
          lng_en: 'Singapore',
          lng_id: 'Singapura',
          lng_th: 'สิงคโปร์',
          lng_zh: '新加坡',
          lng_ko: '싱가포르',
          'vi-VN': 'Singapore',
          'ja-JP': 'シンガポール',
          'zh-TW': '新加坡'
        },
        url: 'https://www.sephora.sg'
      },
      {
        name: {
          lng_en: 'Thailand',
          lng_id: 'Thailand',
          lng_th: 'ไทย',
          lng_zh: '泰國',
          lng_ko: '태국',
          'vi-VN': 'nước Thái Lan',
          'ja-JP': '泰国',
          'zh-TW': '泰國'
        },
        url: 'https://www.sephora.co.th'
      },
      {
        name: {
          lng_en: 'United Arab Emirates',
          lng_id: 'Uni Emirat Arab',
          lng_th: 'สหรัฐอาหรับเอมิเรตส์',
          lng_zh: '阿聯酋',
          lng_ko: '아랍에미리트',
          'vi-VN': 'các Tiểu Vương Quốc Ả Rập Thống Nhất',
          'ja-JP': 'アラブ首長国連邦',
          'zh-TW': '阿拉伯聯合酋長國'
        },
        url: 'https://www.sephora.ae/en'
      },
      {
        name: {
          lng_en: 'Korea',
          lng_id: 'Korea',
          lng_th: 'สาธารณรัฐเกาหลี',
          lng_zh: '韓國',
          lng_ko: '대한민국',
          'vi-VN': 'Korea',
          'ja-JP': '韓国',
          'zh-TW': '朝鮮'
        },
        url: 'https://www.sephora.kr'
      }
    ].sort((a, b) => a.name.lng_en.localeCompare(b.name.lng_en))
  },
  {
    name: {
      lng_en: 'Europe',
      lng_id: 'Eropa',
      lng_th: 'ยุโรป',
      lng_zh: '歐洲',
      lng_ko: '유럽',
      'vi-VN': 'Châu Âu',
      'ja-JP': 'ヨーロッパ',
      'zh-TW': '歐洲'
    },
    group: 'Europe',
    countries: [
      {
        name: {
          lng_en: 'Czech Republic',
          lng_id: 'Republik Ceko',
          lng_th: 'ลักเซมเบิร์ก',
          lng_zh: '捷克',
          lng_ko: '체코 공화국',
          'vi-VN': 'Cộng hòa Séc',
          'ja-JP': 'チェコ共和国',
          'zh-TW': '捷克共和國'
        },
        url: 'https://www.sephora.cz'
      },
      {
        name: {
          lng_en: 'Denmark',
          lng_id: 'Denmark',
          lng_th: 'เดนมาร์ก',
          lng_zh: '丹麥',
          lng_ko: '덴마크',
          'vi-VN': 'Đan mạch',
          'ja-JP': 'デンマーク',
          'zh-TW': '丹麥'
        },
        url: 'https://www.sephora.dk'
      },
      {
        name: {
          lng_en: 'France',
          lng_id: 'Perancis',
          lng_th: 'ฝรั่งเศส',
          lng_zh: '法國',
          lng_ko: '프랑스',
          'vi-VN': 'Nước pháp',
          'ja-JP': 'フランス',
          'zh-TW': '法國'
        },
        url: 'https://www.sephora.fr'
      },
      {
        name: {
          lng_en: 'Germany',
          lng_id: 'Jerman',
          lng_th: 'เยอรมันนี',
          lng_zh: '德國',
          lng_ko: '독일',
          'vi-VN': 'nước Đức',
          'ja-JP': 'ドイツ',
          'zh-TW': '德國'
        },
        url: 'https://www.sephora.de'
      },
      {
        name: {
          lng_en: 'Greece',
          lng_id: 'Yunani',
          lng_th: 'กรีซ',
          lng_zh: '希臘',
          lng_ko: '그리스',
          'vi-VN': 'Hy Lạp',
          'ja-JP': 'ギリシャ',
          'zh-TW': '希臘'
        },
        url: 'https://www.sephora.gr'
      },
      {
        name: {
          lng_en: 'Italy',
          lng_id: 'Italia',
          lng_th: 'อิตาลี',
          lng_zh: '意大利',
          lng_ko: '이탈리아',
          'vi-VN': 'Nước Ý',
          'ja-JP': 'イタリア',
          'zh-TW': '意大利'
        },
        url: 'https://www.sephora.it'
      },
      {
        name: {
          lng_en: 'Luxembourg',
          lng_id: 'Luxembourg',
          lng_th: 'ลักเซมเบิร์ก',
          lng_zh: '盧森堡',
          lng_ko: '룩셈부르크',
          'vi-VN': 'Luxembourg',
          'ja-JP': 'ルクセンブルク',
          'zh-TW': '盧森堡'
        },
        url: 'https://www.sephora.fr/magasins/luxembourg'
      },
      {
        name: {
          lng_en: 'Monaco',
          lng_id: 'Monaco',
          lng_th: 'โมนาโค',
          lng_zh: '摩納哥',
          lng_ko: '모나코',
          'vi-VN': 'Monaco',
          'ja-JP': 'モナコ',
          'zh-TW': '摩納哥'
        },
        url: 'https://www.sephora.fr/magasins/PROVENCE-ALPES-COTE-D-AZUR/MONACO/S4691'
      },
      {
        name: {
          lng_en: 'Poland',
          lng_id: 'Polandia',
          lng_th: 'โปแลนด์',
          lng_zh: '波蘭',
          lng_ko: '폴란드',
          'vi-VN': 'Ba lan',
          'ja-JP': 'ポーランド',
          'zh-TW': '波蘭'
        },
        url: 'https://www.sephora.pl'
      },
      {
        name: {
          lng_en: 'Portugal',
          lng_id: 'Portugal',
          lng_th: 'โปรตุเกส',
          lng_zh: '葡萄牙',
          lng_ko: '포르투갈',
          'vi-VN': 'Bồ Đào Nha',
          'ja-JP': 'ポルトガル',
          'zh-TW': '葡萄牙'
        },
        url: 'https://www.sephora.pt'
      },
      {
        name: {
          lng_en: 'Romania',
          lng_id: 'Romania',
          lng_th: 'โรมาเนีย',
          lng_zh: '羅馬尼亞',
          lng_ko: '루마니아',
          'vi-VN': 'Romania',
          'ja-JP': 'ルーマニア',
          'zh-TW': '羅馬尼亞'
        },
        url: 'https://www.sephora.ro'
      },
      {
        name: {
          lng_en: 'Russia',
          lng_id: 'Russia',
          lng_th: 'รัสเซีย',
          lng_zh: '俄羅斯',
          lng_ko: '러시아',
          'vi-VN': 'Nga',
          'ja-JP': 'ロシア',
          'zh-TW': '俄羅斯'
        },
        url: 'https://www.sephora.fr/storeLocator/storeController.jsp?city=ekaterinbour'
      },
      {
        name: {
          lng_en: 'Serbia',
          lng_id: 'Serbia',
          lng_th: 'เซอร์เบีย',
          lng_zh: '塞爾維亞',
          lng_ko: '세르비아',
          'vi-VN': 'Xéc-bi-a',
          'ja-JP': 'セルビア',
          'zh-TW': '塞爾維亞'
        },
        url: 'https://www.sephora.fr/storeLocator/storeController.jsp?city=belgrad'
      },
      {
        name: {
          lng_en: 'Slovakia',
          lng_id: 'Slovakia',
          lng_th: 'สโลวาเกีย',
          lng_zh: '斯洛伐克',
          lng_ko: '슬로바키아',
          'vi-VN': 'Xlô-va-ki-a',
          'ja-JP': 'スロバキア',
          'zh-TW': '斯洛伐克'
        },
        url: 'https://www.sephora.fr/storeLocator/storeController.jsp?city=bratislav'
      },
      {
        name: {
          lng_en: 'Spain',
          lng_id: 'Spanyol',
          lng_th: 'สเปน',
          lng_zh: '西班牙',
          lng_ko: '스페인',
          'vi-VN': 'Tây Ban Nha',
          'ja-JP': 'スペイン',
          'zh-TW': '西班牙'
        },
        url: 'https://www.sephora.es'
      },
      {
        name: {
          lng_en: 'Switzerland',
          lng_id: 'Switzerland',
          lng_th: 'สวิตเซอร์แลนด์',
          lng_zh: '瑞士',
          lng_ko: '스위스',
          'vi-VN': 'Thụy sĩ',
          'ja-JP': 'スイス',
          'zh-TW': '瑞士'
        },
        url: 'https://ch.sephora.fr'
      },
      {
        name: {
          lng_en: 'Turkey',
          lng_id: 'Turki',
          lng_th: 'ตุรกี',
          lng_zh: '土耳其',
          lng_ko: '터키',
          'vi-VN': 'gà tây',
          'ja-JP': '七面鳥',
          'zh-TW': '火雞'
        },
        url: 'http://www.sephora.com.tr'
      }
    ]
  },
  {
    name: {
      lng_en: 'Oceania',
      lng_id: 'Oceania',
      lng_th: 'โอเชียเนีย',
      lng_zh: '大洋洲',
      lng_ko: '오세아니아',
      'vi-VN': 'Châu đại dương',
      'ja-JP': 'オセアニア',
      'zh-TW': '大洋洲'
    },
    group: 'Oceania',
    countries: [
      {
        name: {
          lng_en: 'Australia',
          lng_id: 'Australia',
          lng_th: 'ออสเตรเลีย',
          lng_zh: '澳洲',
          lng_ko: '호주',
          'vi-VN': 'Châu Úc',
          'ja-JP': 'オーストラリア',
          'zh-TW': '澳大利亞'
        },
        url: 'https://www.sephora.com.au'
      },
      {
        name: {
          lng_en: 'New Zealand',
          lng_id: 'Selandia Baru',
          lng_th: 'นิวซีแลนด์',
          lng_zh: '紐西蘭',
          lng_ko: '뉴질랜드',
          'vi-VN': 'New Zealand',
          'ja-JP': 'ニュージーランド',
          'zh-TW': '新西蘭'
        },
        url: 'https://www.sephora.nz'
      }
    ]
  }
]

const callingCodes = [
  { name: 'Afghanistan', dialCode: '+93', code: 'AF' },
  { name: 'Albania', dialCode: '+355', code: 'AL' },
  { name: 'Algeria', dialCode: '+213', code: 'DZ' },
  { name: 'AmericanSamoa', dialCode: '+1 684', code: 'AS' },
  { name: 'Andorra', dialCode: '+376', code: 'AD' },
  { name: 'Angola', dialCode: '+244', code: 'AO' },
  { name: 'Anguilla', dialCode: '+1 264', code: 'AI' },
  { name: 'Antigua and Barbuda', dialCode: '+1268', code: 'AG' },
  { name: 'Argentina', dialCode: '+54', code: 'AR' },
  { name: 'Armenia', dialCode: '+374', code: 'AM' },
  { name: 'Aruba', dialCode: '+297', code: 'AW' },
  { name: 'Australia', dialCode: '+61', code: 'AU' },
  { name: 'Austria', dialCode: '+43', code: 'AT' },
  { name: 'Azerbaijan', dialCode: '+994', code: 'AZ' },
  { name: 'Bahamas', dialCode: '+1 242', code: 'BS' },
  { name: 'Bahrain', dialCode: '+973', code: 'BH' },
  { name: 'Bangladesh', dialCode: '+880', code: 'BD' },
  { name: 'Barbados', dialCode: '+1 246', code: 'BB' },
  { name: 'Belarus', dialCode: '+375', code: 'BY' },
  { name: 'Belgium', dialCode: '+32', code: 'BE' },
  { name: 'Belize', dialCode: '+501', code: 'BZ' },
  { name: 'Benin', dialCode: '+229', code: 'BJ' },
  { name: 'Bermuda', dialCode: '+1 441', code: 'BM' },
  { name: 'Bhutan', dialCode: '+975', code: 'BT' },
  { name: 'Bosnia and Herzegovina', dialCode: '+387', code: 'BA' },
  { name: 'Botswana', dialCode: '+267', code: 'BW' },
  { name: 'Brazil', dialCode: '+55', code: 'BR' },
  { name: 'British Indian Ocean Territory', dialCode: '+246', code: 'IO' },
  { name: 'Bulgaria', dialCode: '+359', code: 'BG' },
  { name: 'Burkina Faso', dialCode: '+226', code: 'BF' },
  { name: 'Burundi', dialCode: '+257', code: 'BI' },
  { name: 'Cambodia', dialCode: '+855', code: 'KH' },
  { name: 'Cameroon', dialCode: '+237', code: 'CM' },
  { name: 'Canada', dialCode: '+1', code: 'CA' },
  { name: 'Cape Verde', dialCode: '+238', code: 'CV' },
  { name: 'Cayman Islands', dialCode: '+ 345', code: 'KY' },
  { name: 'Central African Republic', dialCode: '+236', code: 'CF' },
  { name: 'Chad', dialCode: '+235', code: 'TD' },
  { name: 'Chile', dialCode: '+56', code: 'CL' },
  { name: 'China', dialCode: '+86', code: 'CN' },
  { name: 'Christmas Island', dialCode: '+61', code: 'CX' },
  { name: 'Colombia', dialCode: '+57', code: 'CO' },
  { name: 'Comoros', dialCode: '+269', code: 'KM' },
  { name: 'Congo', dialCode: '+242', code: 'CG' },
  { name: 'Cook Islands', dialCode: '+682', code: 'CK' },
  { name: 'Costa Rica', dialCode: '+506', code: 'CR' },
  { name: 'Croatia', dialCode: '+385', code: 'HR' },
  { name: 'Cuba', dialCode: '+53', code: 'CU' },
  { name: 'Cyprus', dialCode: '+357', code: 'CY' },
  { name: 'Czech Republic', dialCode: '+420', code: 'CZ' },
  { name: 'Denmark', dialCode: '+45', code: 'DK' },
  { name: 'Djibouti', dialCode: '+253', code: 'DJ' },
  { name: 'Dominica', dialCode: '+1 767', code: 'DM' },
  { name: 'Dominican Republic', dialCode: '+1 849', code: 'DO' },
  { name: 'Ecuador', dialCode: '+593', code: 'EC' },
  { name: 'Egypt', dialCode: '+20', code: 'EG' },
  { name: 'El Salvador', dialCode: '+503', code: 'SV' },
  { name: 'Equatorial Guinea', dialCode: '+240', code: 'GQ' },
  { name: 'Eritrea', dialCode: '+291', code: 'ER' },
  { name: 'Estonia', dialCode: '+372', code: 'EE' },
  { name: 'Ethiopia', dialCode: '+251', code: 'ET' },
  { name: 'Faroe Islands', dialCode: '+298', code: 'FO' },
  { name: 'Fiji', dialCode: '+679', code: 'FJ' },
  { name: 'Finland', dialCode: '+358', code: 'FI' },
  { name: 'France', dialCode: '+33', code: 'FR' },
  { name: 'French Guiana', dialCode: '+594', code: 'GF' },
  { name: 'French Polynesia', dialCode: '+689', code: 'PF' },
  { name: 'Gabon', dialCode: '+241', code: 'GA' },
  { name: 'Gambia', dialCode: '+220', code: 'GM' },
  { name: 'Georgia', dialCode: '+995', code: 'GE' },
  { name: 'Germany', dialCode: '+49', code: 'DE' },
  { name: 'Ghana', dialCode: '+233', code: 'GH' },
  { name: 'Gibraltar', dialCode: '+350', code: 'GI' },
  { name: 'Greece', dialCode: '+30', code: 'GR' },
  { name: 'Greenland', dialCode: '+299', code: 'GL' },
  { name: 'Grenada', dialCode: '+1 473', code: 'GD' },
  { name: 'Guadeloupe', dialCode: '+590', code: 'GP' },
  { name: 'Guam', dialCode: '+1 671', code: 'GU' },
  { name: 'Guatemala', dialCode: '+502', code: 'GT' },
  { name: 'Guinea', dialCode: '+224', code: 'GN' },
  { name: 'Guinea-Bissau', dialCode: '+245', code: 'GW' },
  { name: 'Guyana', dialCode: '+595', code: 'GY' },
  { name: 'Haiti', dialCode: '+509', code: 'HT' },
  { name: 'Honduras', dialCode: '+504', code: 'HN' },
  { name: 'Hungary', dialCode: '+36', code: 'HU' },
  { name: 'Iceland', dialCode: '+354', code: 'IS' },
  { name: 'India', dialCode: '+91', code: 'IN' },
  { name: 'Indonesia', dialCode: '+62', code: 'ID' },
  { name: 'Iraq', dialCode: '+964', code: 'IQ' },
  { name: 'Ireland', dialCode: '+353', code: 'IE' },
  { name: 'Israel', dialCode: '+972', code: 'IL' },
  { name: 'Italy', dialCode: '+39', code: 'IT' },
  { name: 'Jamaica', dialCode: '+1 876', code: 'JM' },
  { name: 'Japan', dialCode: '+81', code: 'JP' },
  { name: 'Jordan', dialCode: '+962', code: 'JO' },
  { name: 'Kazakhstan', dialCode: '+7 7', code: 'KZ' },
  { name: 'Kenya', dialCode: '+254', code: 'KE' },
  { name: 'Kiribati', dialCode: '+686', code: 'KI' },
  { name: 'Kuwait', dialCode: '+965', code: 'KW' },
  { name: 'Kyrgyzstan', dialCode: '+996', code: 'KG' },
  { name: 'Latvia', dialCode: '+371', code: 'LV' },
  { name: 'Lebanon', dialCode: '+961', code: 'LB' },
  { name: 'Lesotho', dialCode: '+266', code: 'LS' },
  { name: 'Liberia', dialCode: '+231', code: 'LR' },
  { name: 'Liechtenstein', dialCode: '+423', code: 'LI' },
  { name: 'Lithuania', dialCode: '+370', code: 'LT' },
  { name: 'Luxembourg', dialCode: '+352', code: 'LU' },
  { name: 'Madagascar', dialCode: '+261', code: 'MG' },
  { name: 'Malawi', dialCode: '+265', code: 'MW' },
  { name: 'Malaysia', dialCode: '+60', code: 'MY' },
  { name: 'Maldives', dialCode: '+960', code: 'MV' },
  { name: 'Mali', dialCode: '+223', code: 'ML' },
  { name: 'Malta', dialCode: '+356', code: 'MT' },
  { name: 'Marshall Islands', dialCode: '+692', code: 'MH' },
  { name: 'Martinique', dialCode: '+596', code: 'MQ' },
  { name: 'Mauritania', dialCode: '+222', code: 'MR' },
  { name: 'Mauritius', dialCode: '+230', code: 'MU' },
  { name: 'Mayotte', dialCode: '+262', code: 'YT' },
  { name: 'Mexico', dialCode: '+52', code: 'MX' },
  { name: 'Monaco', dialCode: '+377', code: 'MC' },
  { name: 'Mongolia', dialCode: '+976', code: 'MN' },
  { name: 'Montenegro', dialCode: '+382', code: 'ME' },
  { name: 'Montserrat', dialCode: '+1664', code: 'MS' },
  { name: 'Morocco', dialCode: '+212', code: 'MA' },
  { name: 'Myanmar', dialCode: '+95', code: 'MM' },
  { name: 'Namibia', dialCode: '+264', code: 'NA' },
  { name: 'Nauru', dialCode: '+674', code: 'NR' },
  { name: 'Nepal', dialCode: '+977', code: 'NP' },
  { name: 'Netherlands', dialCode: '+31', code: 'NL' },
  { name: 'Netherlands Antilles', dialCode: '+599', code: 'AN' },
  { name: 'New Caledonia', dialCode: '+687', code: 'NC' },
  { name: 'New Zealand', dialCode: '+64', code: 'NZ' },
  { name: 'Nicaragua', dialCode: '+505', code: 'NI' },
  { name: 'Niger', dialCode: '+227', code: 'NE' },
  { name: 'Nigeria', dialCode: '+234', code: 'NG' },
  { name: 'Niue', dialCode: '+683', code: 'NU' },
  { name: 'Norfolk Island', dialCode: '+672', code: 'NF' },
  { name: 'Northern Mariana Islands', dialCode: '+1 670', code: 'MP' },
  { name: 'Norway', dialCode: '+47', code: 'NO' },
  { name: 'Oman', dialCode: '+968', code: 'OM' },
  { name: 'Pakistan', dialCode: '+92', code: 'PK' },
  { name: 'Palau', dialCode: '+680', code: 'PW' },
  { name: 'Panama', dialCode: '+507', code: 'PA' },
  { name: 'Papua New Guinea', dialCode: '+675', code: 'PG' },
  { name: 'Paraguay', dialCode: '+595', code: 'PY' },
  { name: 'Peru', dialCode: '+51', code: 'PE' },
  { name: 'Philippines', dialCode: '+63', code: 'PH' },
  { name: 'Poland', dialCode: '+48', code: 'PL' },
  { name: 'Portugal', dialCode: '+351', code: 'PT' },
  { name: 'Puerto Rico', dialCode: '+1 939', code: 'PR' },
  { name: 'Qatar', dialCode: '+974', code: 'QA' },
  { name: 'Romania', dialCode: '+40', code: 'RO' },
  { name: 'Rwanda', dialCode: '+250', code: 'RW' },
  { name: 'Samoa', dialCode: '+685', code: 'WS' },
  { name: 'San Marino', dialCode: '+378', code: 'SM' },
  { name: 'Saudi Arabia', dialCode: '+966', code: 'SA' },
  { name: 'Senegal', dialCode: '+221', code: 'SN' },
  { name: 'Serbia', dialCode: '+381', code: 'RS' },
  { name: 'Seychelles', dialCode: '+248', code: 'SC' },
  { name: 'Sierra Leone', dialCode: '+232', code: 'SL' },
  { name: 'Singapore', dialCode: '+65', code: 'SG' },
  { name: 'Slovakia', dialCode: '+421', code: 'SK' },
  { name: 'Slovenia', dialCode: '+386', code: 'SI' },
  { name: 'Solomon Islands', dialCode: '+677', code: 'SB' },
  { name: 'South Africa', dialCode: '+27', code: 'ZA' },
  { name: 'South Georgia and the South Sandwich Islands', dialCode: '+500', code: 'GS' },
  { name: 'Spain', dialCode: '+34', code: 'ES' },
  { name: 'Sri Lanka', dialCode: '+94', code: 'LK' },
  { name: 'Sudan', dialCode: '+249', code: 'SD' },
  { name: 'Suriname', dialCode: '+597', code: 'SR' },
  { name: 'Swaziland', dialCode: '+268', code: 'SZ' },
  { name: 'Sweden', dialCode: '+46', code: 'SE' },
  { name: 'Switzerland', dialCode: '+41', code: 'CH' },
  { name: 'Tajikistan', dialCode: '+992', code: 'TJ' },
  { name: 'Thailand', dialCode: '+66', code: 'TH' },
  { name: 'Togo', dialCode: '+228', code: 'TG' },
  { name: 'Tokelau', dialCode: '+690', code: 'TK' },
  { name: 'Tonga', dialCode: '+676', code: 'TO' },
  { name: 'Trinidad and Tobago', dialCode: '+1 868', code: 'TT' },
  { name: 'Tunisia', dialCode: '+216', code: 'TN' },
  { name: 'Turkey', dialCode: '+90', code: 'TR' },
  { name: 'Turkmenistan', dialCode: '+993', code: 'TM' },
  { name: 'Turks and Caicos Islands', dialCode: '+1 649', code: 'TC' },
  { name: 'Tuvalu', dialCode: '+688', code: 'TV' },
  { name: 'Uganda', dialCode: '+256', code: 'UG' },
  { name: 'Ukraine', dialCode: '+380', code: 'UA' },
  { name: 'United Arab Emirates', dialCode: '+971', code: 'AE' },
  { name: 'United Kingdom', dialCode: '+44', code: 'GB' },
  { name: 'United States', dialCode: '+1', code: 'US' },
  { name: 'Uruguay', dialCode: '+598', code: 'UY' },
  { name: 'Uzbekistan', dialCode: '+998', code: 'UZ' },
  { name: 'Vanuatu', dialCode: '+678', code: 'VU' },
  { name: 'Wallis and Futuna', dialCode: '+681', code: 'WF' },
  { name: 'Yemen', dialCode: '+967', code: 'YE' },
  { name: 'Zambia', dialCode: '+260', code: 'ZM' },
  { name: 'Zimbabwe', dialCode: '+263', code: 'ZW' },
  { name: 'land Islands', dialCode: '', code: 'AX' },
  { name: 'Antarctica', dialCode: null, code: 'AQ' },
  { name: 'Bolivia, Plurinational State of', dialCode: '+591', code: 'BO' },
  { name: 'Brunei Darussalam', dialCode: '+673', code: 'BN' },
  { name: 'Cocos (Keeling) Islands', dialCode: '+61', code: 'CC' },
  { name: 'Congo, The Democratic Republic of the', dialCode: '+243', code: 'CD' },
  { name: 'Cote d\'Ivoire', dialCode: '+225', code: 'CI' },
  { name: 'Falkland Islands (Malvinas)', dialCode: '+500', code: 'FK' },
  { name: 'Guernsey', dialCode: '+44', code: 'GG' },
  { name: 'Holy See (Vatican City State)', dialCode: '+379', code: 'VA' },
  { name: 'Hong Kong SAR', dialCode: '+852', code: 'HK' },
  { name: 'Iran, Islamic Republic of', dialCode: '+98', code: 'IR' },
  { name: 'Isle of Man', dialCode: '+44', code: 'IM' },
  { name: 'Jersey', dialCode: '+44', code: 'JE' },
  { name: 'Korea, Democratic People\'s Republic of', dialCode: '+850', code: 'KP' },
  { name: 'Korea, Republic of', dialCode: '+82', code: 'KR' },
  { name: 'Lao People\'s Democratic Republic', dialCode: '+856', code: 'LA' },
  { name: 'Libyan Arab Jamahiriya', dialCode: '+218', code: 'LY' },
  { name: 'Macao', dialCode: '+853', code: 'MO' },
  { name: 'Macedonia, The Former Yugoslav Republic of', dialCode: '+389', code: 'MK' },
  { name: 'Micronesia, Federated States of', dialCode: '+691', code: 'FM' },
  { name: 'Moldova, Republic of', dialCode: '+373', code: 'MD' },
  { name: 'Mozambique', dialCode: '+258', code: 'MZ' },
  { name: 'Palestinian Territory, Occupied', dialCode: '+970', code: 'PS' },
  { name: 'Pitcairn', dialCode: '+872', code: 'PN' },
  { name: 'Réunion', dialCode: '+262', code: 'RE' },
  { name: 'Russia', dialCode: '+7', code: 'RU' },
  { name: 'Saint Barthélemy', dialCode: '+590', code: 'BL' },
  { name: 'Saint Helena, Ascension and Tristan Da Cunha', dialCode: '+290', code: 'SH' },
  { name: 'Saint Kitts and Nevis', dialCode: '+1 869', code: 'KN' },
  { name: 'Saint Lucia', dialCode: '+1 758', code: 'LC' },
  { name: 'Saint Martin', dialCode: '+590', code: 'MF' },
  { name: 'Saint Pierre and Miquelon', dialCode: '+508', code: 'PM' },
  { name: 'Saint Vincent and the Grenadines', dialCode: '+1 784', code: 'VC' },
  { name: 'Sao Tome and Principe', dialCode: '+239', code: 'ST' },
  { name: 'Somalia', dialCode: '+252', code: 'SO' },
  { name: 'Svalbard and Jan Mayen', dialCode: '+47', code: 'SJ' },
  { name: 'Syrian Arab Republic', dialCode: '+963', code: 'SY' },
  { name: 'Taiwan', dialCode: '+886', code: 'TW' },
  { name: 'Tanzania, United Republic of', dialCode: '+255', code: 'TZ' },
  { name: 'Timor-Leste', dialCode: '+670', code: 'TL' },
  { name: 'Venezuela, Bolivarian Republic of', dialCode: '+58', code: 'VE' },
  { name: 'Viet Nam', dialCode: '+84', code: 'VN' },
  { name: 'Virgin Islands, British', dialCode: '+1 284', code: 'VG' },
  { name: 'Virgin Islands, U.S.', dialCode: '+1 340', code: 'VI' }
]

export {
  europeanUnion,
  continentsWithCountries,
  callingCodes,
  communicationCountries,
  defaultCountries
}
